import React, { Component, createRef } from "react";
import DataTable from './TableBase';
import Swal from 'sweetalert2';
import 'sweetalert2/src/sweetalert2.scss';
import { IconButton } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { apiCall, getTypes } from "../../helpers/MainHelper";
import withPermissions from "../WithPermissions";
import ReactDOMServer from "react-dom/server";
import ReactLoading from "react-loading";

class OperationTypesTable extends Component {

    constructor(props) {
        super(props);
        this.tableRef = createRef();
        this.state = {
            pending: true
        }

    }
    triggerFetch = (page = 1, size = 10, search = '') => {
        if (this.tableRef.current) {
            this.tableRef.current.fetchData(page, size, search);
        }
    };
    handleTypeDetail = (typeId) => {
        this.props.history.push(`${process.env.PUBLIC_URL}/operation-type-detail/${typeId}`);
    }
    setTypes = async () => {
        const types = await getTypes();
        localStorage.setItem('types', JSON.stringify(types));
    }
    handleDelete = async (typeId) => {
        const result = await Swal.fire({
            title: 'Silmek istediğinize emin misiniz?',
            text: "Bu işlem geri alınamaz!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Evet, sil!',
            cancelButtonText: 'Hayır, iptal et',
            preConfirm: async () => {
                const confirmButton = Swal.getConfirmButton();
                const originalButtonText = confirmButton.innerHTML;
                confirmButton.disabled = true;
                confirmButton.innerHTML = ReactDOMServer.renderToString(<ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />);

                try {
                    await apiCall('business/operation/type/delete/' + typeId, 'delete', null);
                    await this.triggerFetch();
                    return true;
                } catch (error) {
                    return false;
                } finally {
                    confirmButton.innerHTML = originalButtonText;
                    confirmButton.disabled = false;
                }
            }
        });

        if (result.isConfirmed) {
            if (result.value) {
                Swal.fire(
                    'Silindi!',
                    'Servis tipi başarıyla silindi.',
                    'success'
                );
            } else {
                Swal.fire(
                    'Hata!',
                    'Silme işlemi başarısız oldu.',
                    'error'
                );
            }
        }
    }
    render() {
        const { pending } = this.state;
        const { userPermissions } = this.props;
        const userHasViewTypePermission = userPermissions.includes('view setting service type');
        const userHasDeleteTypePermission = userPermissions.includes('delete setting service type');
        const columns = [
            {
                name: 'ID',
                selector: row => row.id,
                sortable: true
            },
            {
                name: 'İsim',
                selector: row => row.name,
                sortable: true
            },

            {
                name: 'İşlem',
                button: true,
                cell: row => (
                    <>

                        {userHasDeleteTypePermission ? (
                            <IconButton className="btn btn-outline-secondary" onClick={() => this.handleDelete(row.id)} style={{ cursor: 'pointer', marginLeft: -15 }}>
                                <button type="button" className="btn btn-outline-danger btn-sm" ><i className="icon-trash"></i></button>
                            </IconButton>
                        ) : ""}


                    </>
                )
            }

        ]
        return (
            <DataTable
                ref={this.tableRef}
                dataEndpoint={"business/operation/type/all"}
                columns={columns}
                onRowClicked={userHasViewTypePermission ? row => this.handleTypeDetail(row.id) : undefined}
                progressPending={pending}>
            </DataTable>
        )
    }

}
export default withPermissions(withRouter(OperationTypesTable));
